/**
 * Focus handling for the two game screens, where focus decides who gets the
 * keys: `input/keyboard.ts` plays a key only when it is aimed at nothing (a
 * press on a focused button belongs to the button).
 */

/**
 * Gives the keys back to the board after "Keep playing", and after anything
 * else that was open over a run closes (the Game menu, Settings, a card the
 * server put over a match).
 *
 * The shell's `Sheet` returns focus to whatever had it when it opened: for
 * the quit question, the Quit button; for the Game menu, its button. That is
 * right for a menu and wrong for a run: there is nothing focusable on the
 * board to move to, so the player's next Space would press that button again.
 * Blurring a focused control inside `scope` leaves focus on the page, where
 * the game reads its keys.
 */
export function returnKeysToBoard(scope: HTMLElement | null | undefined): void {
  const active = document.activeElement;
  if (!(active instanceof HTMLElement) || active === document.body) return;
  if (scope === null || scope === undefined || !scope.contains(active)) return;
  active.blur();
}
